module.exports = __webpack_public_path__ + "static/media/photo-1506784693919-ef06d93c28d2-min-final.0a7eb86f.jpg";